import React from 'react';
import { Navigation } from '../components/Navigation';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function ContactPage() {
  return <div className="min-h-screen bg-[#0f2424] text-white selection:bg-[#4fd1c5] selection:text-[#0f2424]" data-id="element-300">
      <Navigation data-id="element-301" />
      <main className="pt-20" data-id="element-302">
        <ContactSection data-id="element-303" />
      </main>
      <Footer data-id="element-304" />
    </div>;
}